import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

interface AppLoadingScreenProps {
  children: React.ReactNode;
}

export function AppLoadingScreen({ children }: AppLoadingScreenProps) {
  const { isLoading: authLoading } = useAuth();
  
  // Only wait for auth - let individual pages handle their own loading states
  // This prevents the loading screen from blocking when other API calls fail
  const isLoading = authLoading;

  if (isLoading) {
    return (
      <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-background">
        {/* Logo */}
        <div className="mb-8 flex items-center gap-3">
          <svg
            width="48"
            height="48"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="text-foreground"
          >
            <path
              d="M12 2L2 7L12 12L22 7L12 2Z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M2 17L12 22L22 17"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M2 12L12 17L22 12"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span className="text-2xl font-bold text-foreground">BitSwan</span>
        </div>
        
        {/* Spinner */}
        <div className="mb-4">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
        </div>
        
        {/* Status text */}
        <p className="text-sm text-muted-foreground animate-pulse">
          Loading...
        </p>
      </div>
    );
  }

  return <>{children}</>;
}

